import { mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import { locales } from '../../locales/en';
import Button from './Button';
import "./ButtonRefresh.linaria.module.css!=!./ButtonRefresh?./ButtonRefresh.linaria.module.css?css=H4sIAAAAAAAAA12SUY6DIBBA//cWewCb0rXW0sMQxFGni2BxFC3Zu2/arnXxi7zwHmEIO0mtaPaCpfPhNA+7GEMrXY0mcVg3xI/ddPn5eCoqF1VW3XQRU6isoaTHO3CWr/ZJi8nfMMuDsto67hsk+MS2s46koUVrvgSr/GRG2OByDbIdZ4f13HEWzA91b47BY0kNlwPZZfNaPPIO9+fQokleQpau9bkXjCaPow4l9p2WM680vLelE6MbFUwxhYeTlOhAEVrDnfVLUYBgt7NS9X2Dr8Y72XFjH8t7YsGazF6He0xBaqxNggRtzxUYArcU2go8eErTmEInyxJN/XyibJ1RQ6TDVi8skW2j4lvApCgvYnoXGiri7H+go0Bvg9ff+St+AZRK495vAgAA"
const refreshStyles = "atm_h0_14y27yu atm_c8_f6fqlb atm_7l_xwqi68";
const buttonStyles = "atm_h3_1fwxnve atm_vy_1wugsn5 atm_jb_1fwpi09 atm_9s_1txwivl atm_ar_vrvcex atm_be_1q9ccgz atm_h_1h6ojuz atm_lo_i2wt44 atm_le_i2wt44 atm_lk_exct8b atm_ll_exct8b";
const ButtonRefresh = () => {
  const refreshPage = () => {
    if (typeof window === 'undefined') return;
    window.location.reload();
  };
  return <Button data-testid="Button__Refresh" onClick={refreshPage} size="medium" className={buttonStyles}>
            <Icon path={mdiRefresh} size="18px" className={refreshStyles} />{' '}
            {locales.system.refresh_now}
        </Button>;
};
export default ButtonRefresh;